import classes from './IconCardListBlock.module.scss';
import Markdown from 'markdown-to-jsx';
import Image from 'next/image';

export default function IconCardListBlock(props) {
    /**
     * Component expects props at object key 0
     */
    if (!props[0]) return null;
    const {
        0: ComponentContentSiteCopy,
        1: ComponentListIconCopyCardList,
        2: ComponentContentCardTheme
    } = props;

    const imagePosition = ComponentContentCardTheme.image_position;
    const customClass = ComponentContentCardTheme.custom_class;

    return (
        <section
            className={`${classes.oSection} ${classes[imagePosition]} ${classes[customClass]}} oBlock ${imagePosition}`}
        >
            <div className={`${classes.oContainer} container`}>
                <div className={`${classes.oRow} row`}>
                    <div className={`${classes.oColText} col`}>
                        <h2 className={`${classes.aTitle} fnt32`}>
                            {ComponentContentSiteCopy.title}
                        </h2>
                        <Markdown className={`${classes.aCopyText} fnt13f`}>
                            {ComponentContentSiteCopy.copy}
                        </Markdown>
                        <div className={`${classes.oCardListRegion}`}>
                            {ComponentListIconCopyCardList.features_cards.map((card) => {
                                return (
                                    <div
                                        key={card.id}
                                        className={`${classes.oCard} ${classes[card.card_width]} ${
                                            classes[card.custom_class]
                                        }`}
                                    >
                                        <figure className={classes.mImage}>
                                            <Image
                                                src={card.icon.data.attributes.url}
                                                alt={card.icon.data.attributes.alternativeText}
                                                width={card.icon.data.attributes.width}
                                                height={card.icon.data.attributes.height}
                                                className={classes.aImage}
                                                aria-hidden="true"
                                                layout="fixed"
                                                priority="true"
                                            />
                                        </figure>
                                        <p className={`${classes.aTitle} fnt21`}>{card.title}</p>
                                        <Markdown className={`${classes.aCopyText} fnt13f`}>
                                            {card.description}
                                        </Markdown>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
